import React from 'react';
import { Formik, Field, Form, ErrorMessage } from 'formik';

import { hireData } from '../static/data';
import { roleOptions, howDidYouOptions } from '../static/formOptions';

import ScrollToTop from '../components/ScrollToTop';
import SocialBlock from '../components/SocialBlock';
import Intro from '../components/Intro';
import Reasoning from '../components/Reasoning';
import CTA from '../components/CTA';
import Spacer from '../components/Spacer';
import SelectField from '../components/SelectField';
import SEO from '../components/SEO';

import { submitHiringForm } from '../actions/formActions';
import { HiringFormSchema } from '../utils/validationSchema';

import '../css/form.css';
import '../css/hire.css';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

let _HiringForm = ({ submitHiringForm }) => {
  return (
    <Formik
      initialValues={{
        name: '',
        email: '',
        phone: '',
        company: '',
        howDidYou: '',
        message: ''
      }}
      validationSchema={HiringFormSchema}
      onSubmit={(values, actions) => {
        return submitHiringForm(values).then((ret) => {
          if (ret && ret.payload) {
            actions.resetForm();
            actions.setStatus({
              success: "Submitted Successfully! We'll reach out to you shortly"
            });
            // make success message disappear
            setTimeout(() => actions.setStatus({ success: '' }), 6000);
          } else {
            actions.setStatus({
              success:
                'There was an error submitting your request. Try again later.'
            });
          }
        });
      }}
      render={({ status, isSubmitting }) => (
        <Form className="form" id="hiringForm">
          <h2 className="text-light">Let's Connect</h2>
          <fieldset>
            <label>Name</label>
            <Field type="text" name="name" placeholder="Enter your name" />
            <ErrorMessage name="name" component="div" className="error" />
          </fieldset>
          <fieldset>
            <label>Email</label>
            <Field type="email" name="email" placeholder="Enter your email" />
            <ErrorMessage name="email" component="div" className="error" />
          </fieldset>
          <fieldset>
            <label>Phone</label>
            <Field
              type="text"
              name="phone"
              placeholder="Enter your phone number"
            />
            <ErrorMessage name="phone" component="div" className="error" />
          </fieldset>
          <fieldset>
            <label>Company</label>
            <Field
              type="text"
              name="company"
              placeholder="Enter the name of your company"
            />
            <ErrorMessage name="company" component="div" className="error" />
          </fieldset>
          <fieldset>
            <label>Which role are you hiring for?</label>
            <Field
              className="select-box"
              name="role"
              options={roleOptions}
              component={SelectField}
              placeholder="Select..."
              theme={(theme) => ({
                ...theme,
                borderRadius: '10px',
                colors: {
                  ...theme.colors,
                  primary25: '#FAFAFA',
                  primary: '#3DA6FC'
                }
              })}
            />
          </fieldset>
          <fieldset>
            <label>How did you hear about us?</label>
            <Field
              className="select-box"
              name="howDidYou"
              options={howDidYouOptions}
              component={SelectField}
              placeholder="Select..."
              theme={(theme) => ({
                ...theme,
                borderRadius: '10px',
                colors: {
                  ...theme.colors,
                  primary25: '#FAFAFA',
                  primary: '#3DA6FC'
                }
              })}
            />
            <ErrorMessage name="howDidYou" component="div" className="error" />
          </fieldset>
          <fieldset>
            <label>Message</label>
            <Field
              name="message"
              component="textarea"
              placeholder="Type here..."
              rows={8}
              className="text-light"
            />
            <ErrorMessage name="message" component="div" className="error" />
          </fieldset>
          {status && status.success && (
            <div className="success">{status.success}</div>
          )}
          <button
            className="btn btn-filled btn-filled-yellow"
            type="submit"
            disabled={isSubmitting}
          >
            Send
          </button>
        </Form>
      )}
    />
  );
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      submitHiringForm
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {};
}

const HiringForm = connect(mapStateToProps, mapDispatchToProps)(_HiringForm);

function Hire() {
  let { intro, reasoning } = hireData;
  return (
    <>
      <SEO
        title="WE3 Academy | Hire Developers | Coding Bootcamp"
        description="Reach out to us to gain access to top talent. We select motivated individuals and train them with essential technical and workplace skills that helps them become qualified professionals."
        keywords="WE3 Academy, WE3, hire, hire, hiring process, recruitment, career help, careers, career counselling, career guidance services, career guidance and counselling, human resource process, career guidance, it career counselling, job, job search, job search help, hiring help, talent recruiters, talent recruitment"
        link="/hire"
      />
      <div id="hire">
        <ScrollToTop />
        <Intro sectionId="hireIntro" intro={intro} />
        <Reasoning sectionId="hireReasoning" reasoning={reasoning} />

        <section id="hiringConnect">
          <HiringForm />
          <Spacer px={30} />
        </section>
        <CTA styleType="style6" />
        <SocialBlock styleType="style1" />
      </div>
    </>
  );
}

export default Hire;
